(function() {
  var savedY = 0;

  // Scroll-Position vor jedem Klick im Bundle-Bereich speichern
  document.addEventListener('click', function(e) {
    var bundle = e.target.closest('[class*="bundle"], [class*="wb"], [data-section-type]');
    if (bundle) {
      savedY = window.scrollY;
    }
  }, true);

  // Scroll-Position vor jedem Select-Change speichern
  document.addEventListener('change', function(e) {
    savedY = window.scrollY;
  }, true);

  // Nach jedem History/State-Change zurückscrolln (Shopify variant URL update)
  var origPushState = history.pushState;
  history.pushState = function() {
    savedY = window.scrollY;
    origPushState.apply(this, arguments);
    setTimeout(function() { window.scrollTo(0, savedY); }, 50);
    setTimeout(function() { window.scrollTo(0, savedY); }, 200);
  };

  var origReplaceState = history.replaceState;
  history.replaceState = function() {
    savedY = window.scrollY;
    origReplaceState.apply(this, arguments);
    setTimeout(function() { window.scrollTo(0, savedY); }, 50);
    setTimeout(function() { window.scrollTo(0, savedY); }, 200);
  };
})();